
export const SkillStrings = {
    title: "Skills",
    LanguagesTitle: "Languages",
    LanguagesSubTitle: "*in order of most experience",
    SoftwaresTitle: "Software",
    CPP: "C++",
    JS: "JavaScript/TypeScript",
    CSharp: "C#",
    Python: "Python",
    SourceControl: "Perforce and Git",
    IDEs: "Visual Studio + VS Code",
    Design: "Figma and Adobe XD",
    GameEngines: "Unreal Engine 4 & 5",
};

export const ProjectStrings = {
    title: "Projects",
    D2AltText:
        "Destiny 2 promotional image. Characters representing of each of the three playable Destiny 2 classes are posed with weapons beneath the game's logo.",
    THPSAltText:
        "Tony Hawk's Pro Skater 1+2 promotional image. A 3D representation of Tony Hawk is posed skating mid-air off a ramp over the game's logo.",
    WolverineAltText:
        "Marvel's Wolverine box art. A rendering of Wolverine is shown against a yellow background.",
    Spiderman2AltText:
        "Marvel's Spider-Man 2 box art. Miles Morales and Peter Parker are posed in costume against a red background. A logo that reads 'Marvel's Spider-Man 2' is placed above their heads.",

    D2Title: "Destiny 2: Black Armory DLC",
    D2Platform: "PC, Xbox One, and PlayStation 4",
    D2Position: "Software Engineering Intern",
    D2Company: "Vicarious Visions, Investment Team",

    THPSTitle: "Tony Hawk's Pro Skater 1+2",
    THPSPlatform: "Xbox One and PlayStation 4",
    THPSPosition: "Junior Software Engineer",
    THPSCompany: "Vicarious Visions, UI Team",

    WolverineTitle: "Marvel's Wolverine",
    WolverinePlatform: "PlayStation 5",
    WolverinePosition: "Advanced UI/UX Programmer",
    WolverineCompany: "Insomniac Games, UI/UX Team",

    Spiderman2Title: "Marvel's Spider-Man 2",
    Spiderman2Platform: "PlayStation 5",
    Spiderman2Position: "UI/UX Programmer",
    Spiderman2Company: "Insomniac Games, UI/UX Team",

    D2OverlayText: "",
    THPSOverlayText: "",
    WolverineOverlayText: "",
    Spiderman2OverlayText: "",
};

export const BioStrings = {
    title: "Projects",
};
